/**
 * @file history.ts
 * @description Подписи записей истории публикаций (phase19.16 Р1;
 * uiux-design-r1 §6; контракт §6): «Оформление 3, меню 1» по частям,
 * «Возврат версии от 01.10.2026», «Платформа · Стартовая версия: вид сайта
 * до конструктора» для импорта.
 */

import { SITE_VIEW_PART_LABELS } from "@chaiberi/shared";

import { formatShopDateTime } from "../shop-time";
import type { SiteHistoryItem } from "./types";

/** Что менялось: названия частей с заглавной первой буквы. */
export function historySummary(item: SiteHistoryItem, sourceDate?: string | null): string {
  if (item.kind === "IMPORT") return "Стартовая версия: вид сайта до конструктора";
  if (item.kind === "ROLLBACK") {
    return item.sourceVersion !== null
      ? `Возврат версии ${item.sourceVersion}${sourceDate ? ` от ${sourceDate}` : ""}`
      : "Возврат версии";
  }
  if (item.kind === "RESTORE") return "Восстановление из резервной копии";
  const parts = item.changedParts.map((p) => SITE_VIEW_PART_LABELS[p]).join(", ");
  const text = parts || "Без изменений";
  const capital = text.charAt(0).toUpperCase() + text.slice(1);
  return item.note ? `${capital} · ${item.note}` : capital;
}

/** Кто публиковал: импорт — «Платформа». */
export function historyAuthor(item: SiteHistoryItem): string {
  return item.kind === "IMPORT" ? "Платформа" : item.publishedBy.name;
}

/** Дата и время публикации по поясу магазина. */
export function historyWhen(item: SiteHistoryItem): string {
  return formatShopDateTime(item.publishedAt);
}
